import axios from 'axios'
import Vue from 'vue';


function errorResponseHandler(error) {
    // check for errorHandle config
    if (Object.prototype.hasOwnProperty.call(error.config, 'errorHandle') && error.config.errorHandle === false ) {
        return Promise.reject(error);
    }

    const vm = new Vue()
    // if has response show the error 
    if (error.response) {
        vm.$bvToast.toast(`Oh no! Try again or contact support.`, {
            title: `An unexpected error has occurred`,
            toaster: 'b-toaster-bottom-center',
            solid: true
        })
        return Promise.reject(error);
    }
}

// apply interceptor on response
axios.interceptors.response.use(
   response => response,
   errorResponseHandler
);

export default errorResponseHandler;